<span #lukaBot></span>
@defer (on viewport(lukaBot)) {
    <app-luka-chatbot [botInputs]="botInputs()" (overlayHeaderAction)="emitAction($event)"></app-luka-chatbot>
}
